import { mergeClasses } from '@fluentui/react-components';
import React from 'react';
import { Panel, PanelGroup, PanelGroupProps, PanelProps } from 'react-resizable-panels';

import useStyle from './FluentResizablepanelStyle';

interface IFluentPanel extends PanelProps {
	inner?: boolean;
}
export const FluentPanel = (props: IFluentPanel) => {
	const styles = useStyle();
	const { inner } = props;
	return <Panel className={mergeClasses(inner && styles.panelInnerTheme)} {...props} />;
};

export const FluentPanelGroupHorizontal = React.forwardRef<React.ElementRef<typeof PanelGroup>, Omit<PanelGroupProps, 'direction'>>((props, ref) => (
	<PanelGroup ref={ref} {...props} direction="horizontal" />
));

export const FluentPanelGroupVertical = (props: Omit<PanelGroupProps, 'direction'>) => <PanelGroup {...props} direction="vertical" />;
